module.exports = __webpack_public_path__ + "static/media/TrueLove.ChristianPoetryVol.2.OFC.dd09a16a.jpg";